var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBloodTestCbc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.3,
    height: 35.515,
    viewBox: "0 0 27.3 35.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17684"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12483",
    d: "M1203.331-703.586h16.41l4.155 8.019s1.232 4.506-4.155 5.855a13.87 13.87 0 0 1-4.35 0s-5.28-.349-8.292-.421a40.259 40.259 0 0 0-4.842 0l-1.681-.868-1.149-1.628-.453-2.043 1.1-2.894 1.753-3.647z",
    transform: "translate(-1197.959 724.551)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.947 28.067-7.5-14.658V2.081h1.02a1.04 1.04 0 0 0 0-2.081h-13.2a1.04 1.04 0 1 0 0 2.081h1.02v11.328l-7.5 14.658a5.117 5.117 0 0 0 4.554 7.448h17.052a5.117 5.117 0 0 0 4.554-7.448zm-16.7-13.933a1.04 1.04 0 0 0 .114-.474V2.081h7v11.578a1.041 1.041 0 0 0 .114.474l2.9 5.656H66.356zm12.141 19.3H64.336a3.03 3.03 0 0 1-2.859-4.056c.044-.123 3.815-7.507 3.815-7.507h15.146s3.716 7.264 3.742 7.324a3.036 3.036 0 0 1-2.787 4.239z",
    transform: "translate(-59.214)",
    style: {
      fill: "#6f7e8e"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodTestCbc);
export default __webpack_public_path__ + "static/media/Blood Test CBC.cc9550baa915d208a7e491a1a0f31bea.svg";
export { ForwardRef as ReactComponent };